import { Injectable } from '@angular/core';

@Injectable()
export class TimezoneService {
	timezones: Array<Timezone>;
	constructor() {}

	getTimezones(): Array<Timezone> {
		this.timezones = [
			{ key: `-720`, label: `(UTC-12:00) International Date Line West` },
			{ key: `-660`, label: `(UTC-11:00) Midway Island, Samoa` },
			{ key: `-600`, label: `(UTC-10:00) Hawaii` },
			{ key: `-540`, label: `(UTC-09:00) Alaska` },
			{ key: `-480`, label: `(UTC-08:00) Alaska - Daylight Time` },
			{ key: `-480`, label: `(UTC-08:00) Pacific Time (US and Canada); Tijuana` },
			{ key: `-420`, label: `(UTC-07:00) Pacific Time (US and Canada); Tijuana - Daylight Time` },
			{ key: `-420`, label: `(UTC-07:00) Mountain Time (US and Canada); Arizona` },
			{ key: `-360`, label: `(UTC-06:00) Mountain Time (US and Canada); Arizona - Daylight Time` },
			{ key: `-360`, label: `(UTC-06:00) Central Time (US and Canada); Mexico City` },
			{ key: `-300`, label: `(UTC-05:00) Central Time (US and Canada); Mexico City - Daylight Time` },
			{ key: `-300`, label: `(UTC-05:00) Eastern Time (US and Canada); Haiti, Bogota, Indiana(East)` },
			{ key: `-240`, label: `(UTC-04:00) Eastern Time (US and Canada); Haiti, Bogota, Indiana(East) - Daylight Time` },
			{ key: `-270`, label: `(UTC-04:30) Caracas` },
			{ key: `-240`, label: `(UTC-04:00) Atlantic Time (Canada); Georgetown, Santiago` },
			{ key: `-180`, label: `(UTC-03:00) Atlantic Time (Canada); Georgetown, Santiago - Daylight Time` },
			{ key: `-210`, label: `(UTC-03:30) Newfoundland and Labrador` },
			{ key: `-150`, label: `(UTC-02:30) Newfoundland and Labrador - Daylight Time` },
			{ key: `-180`, label: `(UTC-03:00) Brasilia, Buenos Aires, Georgetown, Greenland` },
			{ key: `-120`, label: `(UTC-02:00) Brasilia, Buenos Aires, Georgetown, Greenland - Daylight Time` },
			{ key: `-120`, label: `(UTC-02:00) Mid-Atlantic` },
			{ key: `-60`, label: `(UTC-01:00) Azores, Cape Verde Islands` },
			{ key: `0`, label: `(UTC) Azores, Cape Verde Islands - Daylight Time` },
			{ key: `0`, label: `(UTC) Greenwich Mean Time: Dublin, Edinburgh, Lisbon, London` },
			{ key: `60`, label: `(UTC+01:00) Greenwich Mean Time: Dublin, Edinburgh, Lisbon, London - Daylight Time` },
			{ key: `60`, label: `(UTC+01:00) Amsterdam, Berlin, Rome, Vienna, Budapest, Prague, Madrid, Paris` },
			{ key: `120`, label: `(UTC+02:00) Amsterdam, Berlin, Rome, Vienna, Budapest, Prague, Madrid, Paris - Daylight Time` },
			{ key: `120`, label: `(UTC+02:00) Bucharest, Jerusalem, Helsinki, Kiev, Athens, Istanbul, Minsk` },
			{ key: `180`, label: `(UTC+03:00) Bucharest, Jerusalem, Helsinki, Kiev, Athens, Istanbul, Minsk - Daylight Time` },
			{ key: `180`, label: `(UTC+03:00) Moscow, St. Petersburg, Kuwait, Nairobi, Baghdad` },
			{ key: `210`, label: `(UTC+03:30) Tehran` },
			{ key: `270`, label: `(UTC+04:30) Tehran - Daylight Time` },
			{ key: `240`, label: `(UTC+04:00) Baku, Tbilisi, Yerevan, Volgograd, Abu Dhabi , Muscat` },
			{ key: `270`, label: `(UTC+04:30) Kabul` },
			{ key: `300`, label: `(UTC+05:00) Ekaterinburg, Islamabad, Karachi, Tashkent` },
			{ key: `330`, label: `(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi, Sri Jayawardenepura` },
			{ key: `360`, label: `(UTC+06:00) Astana, Dhaka, Almaty` },
			{ key: `390`, label: `(UTC+06:30) Yangon Rangoon` },
			{ key: `420`, label: `(UTC+07:00) Bangkok, Hanoi, Jakarta, Krasnoyarsk, Novosibirsk` },
			{ key: `480`, label: `(UTC+08:00) Beijing, Hong Kong, Singapore, Taipei, Perth, Irkutsk, Ulaanbaatar` },
			{ key: `540`, label: `(UTC+09:00) Seoul, Osaka, Sapporo, Tokyo, Yakutsk` },
			{ key: `570`, label: `(UTC+09:30) Darwin, Adelaide` },
			{ key: `630`, label: `(UTC+10:30) Darwin, Adelaide - Daylight Time` },
			{ key: `600`, label: `(UTC+10:00) Canberra, Melbourne, Sydney, Brisbane, Guam, Port Moresby` },
			{ key: `660`, label: `(UTC+11:00) Canberra, Melbourne, Sydney, Brisbane, Guam, Port Moresby - Daylight Time` },
			{ key: `660`, label: `(UTC+11:00) Magadan, Solomon Islands, New Caledonia` },
			{ key: `720`, label: `(UTC+12:00) Fiji Islands, Kamchatka, Marshall Islands, Auckland, Wellington` },
			{ key: `780`, label: `(UTC+13:00) Fiji Islands, Kamchatka, Marshall Islands, Auckland, Wellington - Daylight Time` },
			{ key: `780`, label: `(UTC+13:00) Nuku'alofa, Samoa` },
			{ key: `840`, label: `(UTC+14:00) Nuku'alofa, Samoa - Daylight Time` },
			{ key: `840`, label: `(UTC+14:00) Kiritimati Island` }
		];

		return this.timezones;
	}
}

export interface Timezone {
	key: string;
	label: string;
}
